/**
 * Mirrors the signed-in user's toast placement onto <html data-toast-position>
 * so the app-wide Toaster (mounted above the router, see ui/sonner.tsx) can
 * follow it without reaching into page context — the same trick the Toaster
 * already uses for the document language. Signed out, the attribute is
 * removed and the Toaster falls back to its default.
 */
import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { TOAST_POSITION_ATTRIBUTE } from '@/lib/toastPosition';
import { useToastPosition } from './useToastPosition';

export function ToastPositionSync() {
  const { user } = useAuth();
  const { position } = useToastPosition();
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const el = document.documentElement;
    if (user) el.setAttribute(TOAST_POSITION_ATTRIBUTE, position);
    else el.removeAttribute(TOAST_POSITION_ATTRIBUTE);
  }, [user, position]);
  return null;
}
